import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MaterialModule } from '../../material/material.module';
import { CommonModule } from '@angular/common';

declare var $: any;

import Highcharts from 'highcharts';
import Boost from 'highcharts/modules/boost';
import NoData from 'highcharts/modules/no-data-to-display';
import More from 'highcharts/highcharts-more';
import { SharedDataService } from '../services/shared-data.service';

Boost(Highcharts);
NoData(Highcharts);
More(Highcharts);

@Component({
  selector: 'app-chart-proyeccion',
  standalone: true,
  imports: [MaterialModule, CommonModule],
  templateUrl: './chart-proyeccion.component.html',
  styleUrl: './chart-proyeccion.component.less'
})
export class ChartProyeccionComponent implements AfterViewInit, OnInit {

  constructor(
    private sharedDataService: SharedDataService
  ) {}

  ngOnInit(): void {
    this.sharedDataService.simulacionData$.subscribe(data => {
      if (data) {
        this.processSimulacionData(data.investor_details);
      }
    });
  }

  ngAfterViewInit() {
    this.updateChart();
  }

  processSimulacionData(investorDetails: any) {
    if (investorDetails && investorDetails.length > 0) {
      let chartData: any[] = [];
      let previousSimpli = 0;
      let previousDap = 0;

      investorDetails.forEach((item: any, index: number) => {
        const currentSimpli = item.simpli_amount || 0;
        const currentDap = item.dap_amount || 0;

        const formattedDate = this.formatDate(item.date);

        chartData.push({
          simpli: index === 0 ? currentSimpli : currentSimpli - previousSimpli,
          dap: index === 0 ? currentDap : currentDap - previousDap,
          date: formattedDate
        });

        previousSimpli = currentSimpli;
        previousDap = currentDap;
      });

      if (chartData[0].simpli === 0 && chartData[0].dap === 0) {
        chartData.shift();
      }

      this.chartData = chartData;
    } else {
      this.chartData = [
        { simpli: 0, dap: 0, date: '' }
      ];
    }

    this.updateChart();
  }

  updateChart() {
    if (this.options && this.chartData) {
      this.options.xAxis.categories = this.chartData.map(item => item.date);
      this.options.series = [
        {
          name: 'Simpli',
          data: this.chartData.map(item => item.simpli),
          color: '#000467',
        },
        {
          name: 'DAP',
          data: this.chartData.map(item => item.dap),
          color: '#a5abd6',
        },
      ];
      Highcharts.chart('containerProyeccion', this.options);
    }
  }

  chartData: any[] = [];

  options: any = {
    colors: [
      '#000467',
      '#a5abd6',
    ],
    chart: {
      type: 'column',
      spacingBottom: 15, 
    },
    credits: {
      enabled: false,
    },
    title: {
      text: 'Proyección ganancias mensuales vs DAP*',
    },
    xAxis: {
      categories: this.chartData.map((item) => item.date),
      gridLineWidth: 0,
    },
    yAxis: {
      visible: false,
    },
    plotOptions: {
      column: {
        dataLabels: {
          enabled: true,
          style: {
            textOutline: false,
          },
          formatter: function (this: any) {
            return '$' + Highcharts.numberFormat(this.y, 0, ',', '.');
          },
        },
      },
    },
    tooltip: {
      headerFormat: '',
      pointFormatter: function (this: any) {
        return `<span style="color:${this.series.color}; font-align:center"><b>${this.series.name}:</span> $${Highcharts.numberFormat(this.y, 0, ',', '.')}</b>`;
      }
    },
    series: [
      {
        name: 'Simpli',
        data: this.chartData.map((item) => item.simpli),
        color: '#000467',
      },
      {
        name: 'DAP',
        data: this.chartData.map((item) => item.dap),
        color: '#a5abd6',
      },
    ],
  };
  

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return `${('0' + date.getDate()).slice(-2)}/${('0' + (date.getMonth() + 1)).slice(-2)}/${date.getFullYear()}`;
  }
}

